import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { RevenueItemService } from 'src/app/revenue/shared/revenue-items/revenue-item.service';
import { ListingMetadataLego } from '../../shared/dto/listing-metadata.lego';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-listing-lego-edit',
  templateUrl: './listing-lego-edit.component.html',
  styleUrls: ['./listing-lego-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class ListingLegoEditComponent implements OnInit {
  @Input() listingData: ListingMetadataLego;
  revenueItemOptions: Array<SelectItem>;
  constructor(private _revenueItemService: RevenueItemService) {}

  ngOnInit(): void {
    this._revenueItemService.getAllRevenueItems().then((data) => {
      this.revenueItemOptions = data.map((x) => {
        return { label: x.ItemName, value: x.ItemNum } as SelectItem;
      });
    });
    this.listingData.DisplayCategory = true;
  }
}
